/**
 * useCodeList
 * @description 커스텀 훅/유틸리티 - 한 줄 요약 설명을 적습니다.
 * @param {any} [arg] 필요한 인자만 명시합니다.
 * @returns {any 반환 형태를 간단히 요약합니다.}
 * @author 2034236
 * @history
 *   - [2025-12-17] 초기 작성
 */

import { useCallback, useEffect, useRef } from 'react';
import { useGlobalErrorStore } from 'scbk-services';
import { useCodeStore } from '../stores/useCodeStore';
import { Code } from '../types/api/autSetCodList';
import { useAutSetCodList } from './api/authSettingsCodeHooks';

interface Result {
  [category: string]: Code[];
}

export const useCode = (categories: string[], isInit = true) => {
  const { setErrorInfo } = useGlobalErrorStore.getState();
  const { request: list } = useAutSetCodList({
    onError: (error) => {
      setErrorInfo({ ...error, title: `!!!!${error.code}` });
    },
  });

  const { codes, setCodes, getCodes, getCode } = useCodeStore();

  const execList = useCallback(async (input: string[]) => {
    //store에 등록된 카테고리는 제외
    const targets = input.filter((category) => !codes[category]);
    if (targets?.length === 0) {
      //요청목록이 모두 store에 있을경우 return;
      return;
    }

    const result = await list({ categories: targets });

    const resultMap: Result = {};

    result?.categories.forEach((c) => {
      resultMap[c.category] = c.codes;
    });

    setCodes(resultMap);
  }, []);

  const validCategory = useCallback((category: string) => {
    // console.log('categories, ', categories);
    // console.log('category, ', category);

    if (!categories.includes(category)) {
      setErrorInfo({
        code: 'CODE0101',
        title: `[useCode] Category "${category}"는 이 라우터에서 선언되지 않았습니다.`,
      });

      // throw new Error(
      //     `[useCode] Category "${category}"는 이 라우터에서 선언되지 않았습니다.`
      // );
    }
  }, []);

  const isEffect = useRef(false);

  useEffect(() => {
    if (isEffect.current) return;

    if (!categories || categories.length === 0) return;

    if (!isInit) return;

    console.log('categories', categories);

    execList(categories);

    isEffect.current = true;
  }, []);

  return {
    getCode: (category: string, code: string) => {
      validCategory(category);

      return getCode(category, code);
    },
    getCodes: (category: string) => {
      validCategory(category);
      return getCodes(category);
    },
    selectCodes: (category: string) => {
      validCategory(category);
      return getCodes(category).map((code) => {
        return {
          label: code.name,
          value: code.code,
        };
      });
    },
    /**
     * 사용주의 : 일반적인 케이스에서는 사용하지 않음
     * 세션 초기화로 인한 오류방지를 위해 사용
     */
    selectCodesWithInit: async (category: string) => {
      await execList(categories);
      validCategory(category);
      return getCodes(category).map((code) => {
        return {
          label: code.name,
          value: code.code,
        };
      });
    },
  };
};
